/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import React from 'react';

import { useEntiteStore, useModalMajStore } from '@/zustand';

import NotesMiseAJourModal, { NOTES_MISE_A_JOUR } from './NotesMiseAJourModal';

const COOKIE_KEY = 'rco_modal_maj_version';
const COOKIE_EXPIRY_YEARS = 1;

/**
 * Compare la version stockée dans le cookie avec le titre de la note
 * la plus récente (premier élément du tableau). Si une nouvelle note a été
 * ajoutée en tête de tableau, la modal s'affiche automatiquement.
 * Utiliser un cookie (plutôt que localStorage) permet de survivre
 * à un "vider le cache" classique du navigateur.
 */
const getCookieValue = (): string | null => {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${COOKIE_KEY}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : null;
};

const hasNewNotes = (): boolean => {
  const storedVersion = getCookieValue();
  const currentVersion = NOTES_MISE_A_JOUR[0]?.titre ?? '';
  return storedVersion !== currentVersion;
};

const markAsSeen = () => {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + COOKIE_EXPIRY_YEARS);
  // biome-ignore lint/suspicious/noDocumentCookie: .
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(NOTES_MISE_A_JOUR[0]?.titre ?? '')}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
};

interface NotesMiseAJourProviderProps {
  /** Si true, ouvre la modal au montage du composant (indépendamment des nouvelles notes) */
  openOnMount?: boolean;
  /** Si true, appelle history.back() à la fermeture de la modal */
  navigateBackOnClose?: boolean;
}

const NotesMiseAJourProvider = (props: NotesMiseAJourProviderProps) => {
  const { openOnMount = false, navigateBackOnClose = false } = props;

  const selectedEntite = useEntiteStore((state) => state.selectedEntite);
  const open = useModalMajStore((state) => state.open);
  const setOpen = useModalMajStore((state) => state.setOpen);

  React.useEffect(() => {
    if (openOnMount) {
      setOpen(true);
    } else if (selectedEntite && hasNewNotes()) {
      setOpen(true);
    }
  }, [selectedEntite, setOpen, openOnMount]);

  const handleClose = () => {
    markAsSeen();
    setOpen(false);
    if (navigateBackOnClose) {
      window.history.back();
    }
  };

  return <NotesMiseAJourModal open={open} onClose={handleClose} />;
};

export default NotesMiseAJourProvider;
